import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const welcomeMatSelector = createSelector(testTargetOffersSelector, offers => offers.showWelcomeMat || Empty.Object);

export { welcomeMatSelector };
